"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NomosArchwayClient = void 0;
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const nomosClient_1 = require("../nomosClient");
const communicator_1 = require("../../communicator");
const archway_1 = require("../../../types/archway");
class NomosArchwayClient extends nomosClient_1.NomosClient {
    constructor(tmClient) {
        super(tmClient);
        this.communicator = new communicator_1.PostMessageCommunicator(true);
    }
    static connect(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const tmClient = yield tendermint_rpc_1.Tendermint34Client.connect(endpoint);
            return NomosArchwayClient.create(tmClient);
        });
    }
    static connectWithBatchClient(endpoint, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const rpcClient = new tendermint_rpc_1.HttpBatchClient(endpoint, options);
            const tmClient = yield tendermint_rpc_1.Tendermint34Client.create(rpcClient);
            return NomosArchwayClient.create(tmClient);
        });
    }
    static create(tmClient) {
        return __awaiter(this, void 0, void 0, function* () {
            return new NomosArchwayClient(tmClient);
        });
    }
    static createSync(tmClient) {
        return new NomosArchwayClient(tmClient);
    }
    getBlockRewardsTracking() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.getBlockRewardsTracking, {});
            return data.blockTracking;
        });
    }
    getContractMetadata(contract) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.getContractMetadata, { contract });
            return data.metadata;
        });
    }
    getContractPremium(contract) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.getContractPremium, { contract });
            return data.premium;
        });
    }
    getEstimateTxFees(gasLimit, contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.estimateTxFees, {
                gasLimit,
                contractAddress,
            });
            return data.fees;
        });
    }
    getOutstandingRewards(rewardsAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.getOutstandingRewards, {
                rewardsAddress,
            });
            return data.rewards;
        });
    }
    getRewardsPool() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.getRewardsPool, {});
            return data.rewards;
        });
    }
    getAllRewardsRecords(rewardsAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.communicator.send(archway_1.ArchwayMethods.getAllRewardsRecords, {
                rewardsAddress,
            });
            return data.records;
        });
    }
}
exports.NomosArchwayClient = NomosArchwayClient;
//# sourceMappingURL=archwayNomosClient.js.map